import React from 'react';
import { Outlet } from 'react-router-dom';

/** Conteneur pour /my-fund (relevé) et /my-fund/financial (Ledgera). */
export default function MyFundLayout() {
  return <Outlet />;
}
